<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="500px"
            @keydown.esc="close"
  >
    <v-card>
      <div class="add_fa" style="height: 270px">
        <button class="close_bt" @click="close"></button>
        <span class="s_pop_title" style="font-size: 17pt; margin-bottom: 20px">{{ editBuilding.buildingTitile }}</span>
        <input 
            solo
            placeholder="건물"
            v-model="editBuilding.editBuildingName"
            v-on:keyup.enter="createBookmark()">       
        <div class="btnArea">
          <button type="submit" class="btn type3" @click="addBuilding()">저장</button>
          <button type="submit" class="btn type3 reset" @click="close()">취소</button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
export default {
  components: {
  },
  props: [
    'dialog',
    'companyId',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
      defaultBuilding: {
        buildingTitile: '건물 추가',
        corpId: null,
        buildingId: null,
        editBuildingName: null,
      },
      editBuilding: {
        buildingTitile: '건물 추가',
        corpId: null,
        buildingId: null,
        editBuildingName: null,
      },
    };
  },
  mounted () {
    this.loading = false;
  },
  methods: {
    init () {
      this.editBuilding = Object.assign({}, this.defaultBuilding);
    },
    async addBuilding () {
      /* 사업장추가팝업 > 추가 */
      let buildingName = this.editBuilding.editBuildingName;
      let buildingId = this.editBuilding.buildingId;
      let companyId = this.companyId;

      let params = { 'buildingId': buildingId, 'buildingName': buildingName, 'companyId': companyId };

      await this.$http.post('/api/v1/building/addBuilding', params).then(response => {
        console.log(response);
        if (response.status === 200) {
          Util.snackBarOpen(this.$t('빌딩 정보가 적용되었습니다.'), 'primary');
          this.init();
          this.closeDialog();
          this.companyList = [];
        }
      }).catch(error => {
        console.log(error);
      });
    },
    close () {
      this.init();
      this.closeDialog();
    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/popup/BuildingCreateDialog.vue